import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';
import { selectUserIsIdentified } from 'core/selectors/user';

import { selectInstoreOffersConfig } from '../../OffersSection/selectors';

import {
  selectInstoreCuratedOffersContentIsLoading, selectInstoreCuratedOffersContentIsLoaded,
  selectInstoreCuratedOffersPlacements,
} from '../selectors';

export const useGetContent = () => {
  const dispatch = useDispatch();
  const config = useSelector(selectInstoreOffersConfig);
  const isLoading = useSelector(selectInstoreCuratedOffersContentIsLoading);
  const isLoaded = useSelector(selectInstoreCuratedOffersContentIsLoaded);
  const instoreOffers = useSelector(selectInstoreCuratedOffersPlacements);
  const isUserIdentified = useSelector(selectUserIsIdentified);

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      const { curatedOffersApi: { params, options } } = config;

      const { instoreData } = window;

      if (isUserIdentified && instoreData) {
        const { cardholderId } = instoreData;

        if (cardholderId) {
          params.applicable_cardholder_id = cardholderId;
        }
      }
      dispatch(fetchPlacements(params, options));
    }
  }, [config, isLoading, isLoaded, isUserIdentified]);

  return {
    isLoaded,
    isLoading,
    instoreOffers,
  };
};
